import { SaveCode } from './SaveCode/SaveCode';
import { SaveCodeCategory } from './SaveCodeCategory/SaveCodeCategory';

/**
 * mutations
 *
 * @type {{SaveCode: ((function({}=): Promise<*>)|*), SaveCodeCategory: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  SaveCode,
  SaveCodeCategory,
};
